export default __webpack_public_path__ + "static/media/330_store05-en-mobile.94bfcf75.png";